module.exports = __webpack_public_path__ + "img/broken-icon4.98e11c43.png";